import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const StaticCmsPage = loadable(() => pMinDelay(import('./StaticCmsPage'), 300), {
  fallback: <Loading />
});

const AsyncStaticPages = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <StaticCmsPage { ...props }/>
    </ApplicationLayout>
  );
};

AsyncStaticPages.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncStaticPages;
